module.exports = __webpack_public_path__ + "static/img/web_gif1.525eccd.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web_gif1.gif
// module id = ak3B
// module chunks = 0